module Meevo.Plugins.OnlinePresenceSettings {
    class CategoriesDropDown implements ng.IComponentController {
        static $inject = [
            '$scope',
            '$window',
        ];

        searchTerm = '';
        list: ICategory[];
        value: any;
        model: ng.INgModelController;
        disabled: boolean;

        constructor(private _scope: ng.IScope,
                    private _window: ng.IWindowService) {
        }

        resultList: ICategory[] = [];

        $onInit() {
            this.value = this.model.$viewValue;
            this.resultList = this.list;

            const unwatch = this._scope.$watch(() => this.model.$viewValue, (newValue) => {
                if (typeof newValue === 'number' && !isNaN(newValue) && newValue !== this.value) {
                    setTimeout(() => {
                        this._scope.$apply(() => {
                            this.value = newValue;
                            unwatch();
                        });
                    }, 100);
                }
            });
        }

        onDropDownClosed() {
            this.searchTerm = '';

            this.onSearchChange();
        }

        onDropdownOpen() {
            setTimeout(() => {
                this._scope.$apply(() => {
                    const el = this._window.document.getElementById('searchCategoryField');
                    if (el) {
                        el.focus();
                    }
                });
            }, 1000);
        }

        onSearchChange() {
            this.resultList = this._doSearch();
        }

        onItemSelected() {
            this.model.$setViewValue(this.value);
        }

        private _doSearch(): ICategory[] {
            if (!this.searchTerm) return this.list;

            const searchWords = this.searchTerm
                .toString()
                .toLowerCase()
                .split(' ');

            return this.list.filter(row => {
                const name = row.name.toLowerCase();

                return searchWords.reduce((includes: boolean, searchWord: string) => {
                    return includes && name.includes(searchWord);
                }, true);
            });
        }
    }

    angular.module('meevo.plugins.onlinePresenceSettings')
        .component('opsCategoriesDropDown', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/onlinePresenceSettings/components/categories-drop-down.html',
            controller: CategoriesDropDown,
            controllerAs: '$ctrl',
            require: {
                model: '^ngModel',
            },
            bindings: {
                required: '=ngRequired',
                disabled: '=ngDisabled',
                list: '<'
            }
        });
}
